import { ReactNode, useEffect, useRef, useState } from "react";

type LazyMountProps = {
  children: ReactNode;
  placeholder?: ReactNode;
  rootMargin?: string;
  minHeight?: number | string;
};

const LazyMount = ({
  children,
  placeholder,
  rootMargin = "800px",
  minHeight,
}: LazyMountProps) => {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    if (mounted) return;

    const element = containerRef.current;
    if (!element) return;

    if (typeof window === "undefined" || !("IntersectionObserver" in window)) {
      setMounted(true);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          setMounted(true);
          observer.disconnect();
        }
      },
      { rootMargin },
    );

    observer.observe(element);
    return () => observer.disconnect();
  }, [mounted, rootMargin]);

  return (
    <div ref={containerRef} style={minHeight ? { minHeight } : undefined}>
      {mounted ? children : placeholder ?? null}
    </div>
  );
};

export default LazyMount;

